export default function Blobs({ dark }: { dark: boolean }) {
  return (
    <>
      {/* Cloud Kiri Atas (improved, more rounded, soft) */}
      {dark ? (
        <svg
          className="absolute top-[-60px] left-[-120px] w-[400px] h-[160px] opacity-18 -z-10 pointer-events-none"
          viewBox="0 0 400 160"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M60,90 Q80,30 170,60 Q210,10 300,50 Q390,120 340,140 Q220,180 120,140 Q20,130 60,90Z" fill="#232634" />
        </svg>
      ) : (
        <svg
          className="absolute top-[-60px] left-[-120px] w-[400px] h-[160px] opacity-18 -z-10 pointer-events-none"
          viewBox="0 0 400 160"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M60,90 Q80,30 170,60 Q210,10 300,50 Q390,120 340,140 Q220,180 120,140 Q20,130 60,90Z" fill="#a6adc8" />
        </svg>
      )}
      {/* Cloud Bawah Kanan */}
      {dark ? (
        <svg
          className="absolute bottom-[-30px] right-[-80px] w-[320px] h-[100px] opacity-14 -z-10 pointer-events-none"
          viewBox="0 0 320 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M80,90Q120,50,180,65Q230,20,270,60Q310,100,200,95Q100,110,80,90Z" fill="#313244" />
        </svg>
      ) : (
        <svg
          className="absolute bottom-[-30px] right-[-80px] w-[320px] h-[100px] opacity-14 -z-10 pointer-events-none"
          viewBox="0 0 320 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M80,90Q120,50,180,65Q230,20,270,60Q310,100,200,95Q100,110,80,90Z" fill="#b4befe" />
        </svg>
      )}
      {/* Cloud Accent Kecil */}
      {dark ? (
        <svg
          className="absolute top-[32%] left-[22%] w-28 h-10 opacity-10 -z-10 pointer-events-none"
          viewBox="0 0 120 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="60" cy="20" rx="55" ry="14" fill="#45475a" />
        </svg>
      ) : (
        <svg
          className="absolute top-[32%] left-[22%] w-28 h-10 opacity-10 -z-10 pointer-events-none"
          viewBox="0 0 120 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="60" cy="20" rx="55" ry="14" fill="#f9e2af" />
        </svg>
      )}
    </>
  );
}
